export class KeyNavigationGlobalCache {
  public static topItemRefs: HTMLDivElement[] = [];
}